import { createElement } from "react";
import { createObj } from "./fable_modules/fable-library.3.7.1/Util.js";
import { join } from "./fable_modules/fable-library.3.7.1/String.js";
import { Interop_reactApi } from "./fable_modules/Feliz.1.67.0/Interop.fs.js";
import { singleton, ofArray } from "./fable_modules/fable-library.3.7.1/List.js";

export function view() {
    let elems_4, elems_3, elems, elems_2, elems_1, children, children_2, children_4, children_6;
    return createElement("div", createObj(singleton((elems_4 = [createElement("div", createObj(singleton((elems_3 = [createElement("h1", {
        className: join(" ", ["title"]),
        children: "Feliz.TanStack.Table",
    }), createElement("p", createObj(ofArray([["className", join(" ", ["pb-4"])], (elems = ["Feliz style bindings for ", createElement("a", {
        children: "TanStack Table",
        href: "https://tanstack.com/table/v8",
    }), "."], ["children", Interop_reactApi.Children.toArray(Array.from(elems))])]))), createElement("h2", {
        className: join(" ", ["subtitle"]),
        children: "Getting Started",
    }), createElement("div", createObj(ofArray([["className", join(" ", ["content"])], (elems_2 = [createElement("ol", createObj(singleton((elems_1 = [(children = ofArray(["Add the @tanstack/react-table ", createElement("a", {
        children: "npm package",
        href: "https://www.npmjs.com/package/@tanstack/react-table",
    }), " (", createElement("code", {
        children: ["npm i @tanstack/react-table"],
    }), "/", createElement("code", {
        children: ["yarn install @tanstack/react-table"],
    }), "/", createElement("code", {
        children: ["Femto"],
    }), ")."]), createElement("li", {
        children: Interop_reactApi.Children.toArray(Array.from(children)),
    })), (children_2 = ofArray([createElement("a", {
        children: "Install the nuget package.",
        href: "https://www.nuget.org/packages/Feliz.TanStack.Table",
    }), " (", createElement("code", {
        children: ["Install-Package Feliz.TanStack.Table"],
    }), ")."]), createElement("li", {
        children: Interop_reactApi.Children.toArray(Array.from(children_2)),
    })), (children_4 = ofArray(["Have a look at the examples, ", createElement("a", {
        children: "which closely follow the official React examples",
        href: "https://tanstack.com/table/v8/docs/",
    }), "."]), createElement("li", {
        children: Interop_reactApi.Children.toArray(Array.from(children_4)),
    }))], ["children", Interop_reactApi.Children.toArray(Array.from(elems_1))]))))], ["children", Interop_reactApi.Children.toArray(Array.from(elems_2))])]))), createElement("h2", {
        className: join(" ", ["subtitle"]),
        children: "Mutability and Elmish",
    }), (children_6 = ofArray(["TanStack.Table relies on internal mutation to maintain the table state. ", "This means that many of the methods that effect the table state return ", createElement("code", {
        children: ["unit"],
    }), ", instead of a new", createElement("code", {
        children: ["Table\u003c\u0027T\u003e"],
    }), ". To force re-render in Elmish, the state should be reassigned in the ", "update function, e.g.: ", createElement("code", {
        children: [" { state with Table = state.Table }"],
    }), "."]), createElement("p", {
        children: Interop_reactApi.Children.toArray(Array.from(children_6)),
    }))], ["children", Interop_reactApi.Children.toArray(Array.from(elems_3))]))))], ["children", Interop_reactApi.Children.toArray(Array.from(elems_4))]))));
}

//# sourceMappingURL=Home.fs.js.map
